exports.default = {
  'build_ideas_with_ai': 'Build Ideas with AI Teams',
  'enter_your_question': 'Enter your question...',
  'upload_image': 'Upload image',
  'invalid_image_format': 'Image format must be PNG, JPEG, JPG or WebP',
  'image_size_limit': 'Image size cannot exceed 20MB',
  'custom_agents': 'Custom Agents',
  'all_agents': 'All Agents',
  'agent_tools_nav_label': 'Agent feature shortcuts',
  'content_creation': 'Content Creation',
  'all_agents_tip_1': 'View all agents and official recommendations',
  'all_agents_tip_2': 'Filter by scenario and enter the right agent',
  'custom_agents_tip_1': 'Create or manage custom agents',
  'custom_agents_tip_2': 'Build your own workflows and team capabilities',
  'ai_slides': 'AI Slides',
  'ai_slides_prompt': 'Help me create a presentation about: ',
  'ai_sheets': 'AI Sheets',
  'ai_sheets_prompt': 'Help me organize a table for: ',
  'ai_docs': 'AI Docs',
  'ai_docs_prompt': 'Help me write a document about: ',
  'ai_designer': 'AI Designer',
  'ai_designer_prompt': 'Help me design a solution for: ',
  'ai_chat': 'AI Chat',
  'ai_chat_prompt': 'I want to ask about: ',
  'ai_image': 'AI Image',
  'ai_image_prompt': 'Help me generate an image of: ',
  'ai_music': 'AI Music',
  'ai_music_prompt': 'Help me create a music idea in this style: ',
  'ai_video': 'AI Video',
  'ai_video_prompt': 'Help me create a video script about: ',
  'ai_meeting': 'AI Notes',
  'ai_meeting_prompt': 'Help me summarize meeting notes from: ',
  'unlimited_badge': 'Unlimited',
  'text_agent_selector': 'Text agent capsule',
  'text_agent_default_desc': 'Select a text agent to help understand the request',
  'no_text_agents': 'No text agents available',
  'web_entry_agent_missing': 'No AI Web agent entry is available',
  'agent_coming_soon': 'Coming soon',
  'featured_cases': 'Featured Cases',
  'recents': 'Recent',
  'view_all': 'View all',
  'no_recents': 'No recent cases',
  'more': 'More',
  'new_web_case': 'New website case',
  'featured_templates': 'Featured Templates',
  'default': 'Default',
  'latest': 'Latest',
  'popular': 'Popular',
  'all': 'All',
  'preview': 'Preview',
  'no_more_data': 'No more data',
  'max_upload_images': 'Upload up to {count} images at most',
  'remixes': 'Remixes',
  'file_size_limit': 'Upload image size cannot exceed 20MB',
  'paste_content_too_long': 'Pasted content is too long, truncated to {count} characters',
  'content_too_long': 'Content is too long, truncated to {count} characters',
  'short_text_insert_failed': 'Failed to insert short text',
  'chunk_insert_failed': 'Failed to insert chunk',
  'file_read_failed': 'Failed to read file',
  'image_compress_failed': 'Failed to compress image',
  'use_template': 'Use template',
  'use_template_desc': 'By using this template, you will create a copy that you own.',
  'mode_title': 'Mode',
  'mode_desc': 'Set the AI mode. Faster modes consume fewer credits, smarter modes deliver better results.',
  'mode_recommended': 'Recommended',
  'mode_lite': 'Lite',
  'mode_lite_desc': 'Economical option, uses fewer credits for the same task.',
  'mode_standard': 'Standard',
  'mode_standard_desc': 'Suitable for most tasks.',
  'mode_ultra': 'Ultra',
  'mode_ultra_desc': 'Uses the platform-configured strongest model for complex reasoning and long tasks. Ultra mode consumes more credits.',
  'model_selector': 'Select Pai model',
  'selected_text_model': 'Selected text model',
  'model_reasoning': 'Reasoning',
  'model_image': 'Image',
  'no_image_models': 'No image models available',
  'model_not_support_image': 'The current model does not support reference images. Change the model or remove the images before sending.',
  'image_model_reference_limit': 'This image model supports up to {count} reference images. Please adjust them before sending.'
}
